import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Lottie from 'react-lottie';
import * as loader from './loader.json';

const Overlay = styled.div`
  width: 100%;
  position: fixed;
  z-index: 3;
  background: rgba(255, 255, 255, 0.5);
  top: 300px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 153px;
`;

const Msg = styled.p`
  margin: 0;
  color: ${props => props.theme.bodyColor};
`;

const Button = styled.button`
  color: ${props => props.theme.secondaryColor};
  background-color: transparent;
  border: none;
  padding: 0;
  outline: none;
`;

/* stylelint-disable selector-type-no-unknown */
const Container = styled.div`
  border: 1px solid ${props => props.theme.secondaryColor};
  width: 384px;
  height: 74px;
  padding: 0 24px;
  border-radius: 4px;
  background: white;
  box-shadow: ${props => props.theme.dashboardLBoxShadow};
  display: flex;
  align-items: center;

  & ${Msg}, & ${Button} {
    text-transform: uppercase;
    font: ${props => props.theme.fontWeightHeavy} 14px/17px ${props => props.theme.fontFamilyBody};
  }
`;
/* stylelint-enable selector-type-no-unknown */

const VFlex = styled.div`
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export default function Loader({ cancellable, onCancel }) {
  const animationOptions = {
    loop: true,
    autoplay: true,
    animationData: loader.default,
    rendererSettings: {
      perserveAspectRatio: 'xMidYMid slice',
      progressiveLoad: true,
    },
  };

  return (
    <Overlay>
      <Container>
        <VFlex>
          <Msg>fetching your data</Msg>
          {!!cancellable && <Button type="button" onClick={onCancel}>cancel</Button>}
        </VFlex>
        {
          /*
            The dimension here is bigger than the height of the container because
            the animation asset container extra blank spaces around the margin.
          */
        }
        <Lottie options={animationOptions} width={90} height={90} isClickToPauseDisabled />
      </Container>
    </Overlay>
  );
}

Loader.propTypes = {
  cancellable: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};
